import { BreadcrumbsFragment } from 'listing-details/components/ListingBreadcrumbs/ListingBreadcrumbs.types';
import { ListingHeadFragment } from 'listing-details/components/ListingHead/ListingHead.types';
import { MAIN_SITE_LINK } from '../../constants';
import { SCHEMA_CONSTANTS } from '../../shared/seo/schemaConstants';

const getBreadcrumbSchema = (
    canonicalPath: string,
    breadcrumbs?: BreadcrumbsFragment
) => {
    if (!breadcrumbs || breadcrumbs.length === 0) return undefined;
    const lastBreadCrumbUri = `${canonicalPath}`;
    const breadcrumbItems = breadcrumbs.map((breadcrumb, index) => {
        return {
            position: index + 1,
            item: {
                name: breadcrumb.label,
                '@id': `${MAIN_SITE_LINK}${breadcrumb.uri || lastBreadCrumbUri}`
            },
            '@type': SCHEMA_CONSTANTS.LIST_ITEM
        };
    });

    return {
        itemListElement: breadcrumbItems,
        '@type': SCHEMA_CONSTANTS.BREADCRUMB_LIST
    };
};

export const getSeoSchemaJson = (
    url: string,
    canonicalPath: string,
    imageBasePath: string,
    breadcrumbs: BreadcrumbsFragment,
    listing: ListingHeadFragment
) => {
    const {
        branch,
        title,
        metaDescription: description,
        displayAddress,
        location,
        analyticsTaxonomy,
        propertyImage: images
    } = listing;

    return JSON.stringify(
        {
            '@context': SCHEMA_CONSTANTS.SCHEMA,
            '@graph': [
                {
                    '@type': SCHEMA_CONSTANTS.WEBSITE,
                    name: SCHEMA_CONSTANTS.NAME,
                    alternateName: SCHEMA_CONSTANTS.ALTERNATE_NAME,
                    url: `${MAIN_SITE_LINK}/`
                },
                {
                    '@type': SCHEMA_CONSTANTS.REAL_ESTATE_AGENT,
                    name: branch?.name,
                    url: `${MAIN_SITE_LINK}${branch?.branchDetailsUri}`,
                    logo: {
                        '@type': SCHEMA_CONSTANTS.IMAGE_OBJECT,
                        contentUrl: branch?.logoUrl
                    },
                    image: branch?.logoUrl,
                    address: {
                        '@type': SCHEMA_CONSTANTS.POSTAL_ADDRESS,
                        streetAddress: branch?.address,
                        postalCode: branch?.postcode
                    },
                    telephone: branch?.phone
                },
                {
                    '@context': SCHEMA_CONSTANTS.SCHEMA,
                    breadcrumb: getBreadcrumbSchema(canonicalPath, breadcrumbs),
                    id: `${url}`,
                    '@type': SCHEMA_CONSTANTS.WEBPAGE
                },
                {
                    '@type': SCHEMA_CONSTANTS.RESIDENCE,
                    name: title,
                    description: description,
                    address: {
                        '@type': SCHEMA_CONSTANTS.POSTAL_ADDRESS,
                        streetAddress: displayAddress,
                        addressLocality: analyticsTaxonomy?.location,
                        addressRegion: analyticsTaxonomy?.regionName
                    },
                    geo: {
                        '@type': SCHEMA_CONSTANTS.GEO,
                        latitude: location?.coordinates?.latitude,
                        longitude: location?.coordinates?.longitude
                    },
                    photo: images?.map((image) => {
                        return {
                            '@type': SCHEMA_CONSTANTS.IMAGE_OBJECT,
                            contentUrl: `${imageBasePath}${image.filename}`
                        };
                    })
                }
            ]
        },
        null,
        '\t'
    );
};
